import React, { useState, Fragment } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faSyncAlt, faSearch, faKey, faList, faTable, faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
// import Filter from '../../Filter';
// import Table from '../../Table';
// import Pagination from '../../TablePagination';
// import LimitButton from '../../LimitSelectBox';
import BookingCreate from './BookingCreate';
import ExcelUpload from './ExcelUpload';
import BookingDetail from './BookingDetail2';
import BookingUpdate from './BookingUpdate';
import KeyIssue from '../userkeys/UserkeyIssue';
import BookingCancel from './BookingCancel';
import { bookingDateFormatter } from '../../../lib/formatter';

const BookingListCard = ({
  bookingListTotal,
  bookingListItems,
  buildingListItems,
  floorListItems,
  filterItem,
  paginationItem,
  viewType,
  listFloorApi,
  listBookingApi,
  setFilterItem,
  setPaginationItem,
  changeViewType,
  history,
}) => {
  const [ isOpenBookingDetailModal, setIsOpenBookingDetailModal ] = useState(false);
  const [ isOpenBookingCreateModal, setIsOpenBookingCreateModal ] = useState(false);
  const [ isOpenExcelUploadModal, setIsOpenExcelUploadModal ] = useState(false);
  const [ isOpenBookingUpdateModal, setIsOpenBookingUpdateModal ] = useState(false);
  const [ isOpenKeyIssueModal, setIsOpenKeyIssueModal ] = useState(false);
  const [ isOpenBookingCancelModal, setIsOpenBookingCancelModal ] = useState(false);
  const [ selectedBookingId, setSelectedBookingId ] = useState(null);
  // const [ currentPageNumber, setCurrentPageNumber ] = useState(1);

  const selectBuilding = async (buildingId) => {
    await listFloorApi(buildingId);
  };

  // const changePagination = (pageNumber) => {
  //   setCurrentPageNumber(pageNumber);
  //   setPaginationItem({
  //     ...paginationItem,
  //     offset: (pageNumber - 1) * paginationItem.limit,
  //   });
  // };

  // const changeLimit = (limit) => {
  //   setCurrentPageNumber(1);
  //   setPaginationItem({
  //     offset: 0,
  //     limit,
  //   });
  // };

  // const changeFilterItem = (targetItem) => {
  //   setFilterItem({
  //     ...filterItem,
  //     ...targetItem,
  //   });
  //   setCurrentPageNumber(1);
  //   setPaginationItem({
  //     ...paginationItem,
  //     offset: 0,
  //   });
  // };

  const changePrevDate = (date) => {
    setFilterItem({
      ...filterItem,
      startAt: moment(date).subtract(1, 'day').startOf('day').toDate(),
      endAt: moment(date).subtract(1, 'day').endOf('day').toDate(),
    });
  };

  const changeNextDate = (date) => {
    setFilterItem({
      ...filterItem,
      startAt: moment(date).add(1, 'day').startOf('day').toDate(),
      endAt: moment(date).add(1, 'day').endOf('day').toDate(),
    });
  };

  // const initFilterItem = () => {
  //   setFilterItem({
  //     buildingId: '',
  //     roomName: '',
  //     phoneNumber: '',
  //     startAt: moment().startOf('day').toDate(),
  //     endAt: moment().endOf('day').toDate(),
  //   });
  //   setCurrentPageNumber(1);
  //   setPaginationItem({
  //     ...paginationItem,
  //     offset: 0,
  //   });
  // };

  const selectBookingDetail = (bookingId) => {
    setSelectedBookingId(bookingId);
    setIsOpenBookingDetailModal(true);
  };

  const selectBookingUpdate = (bookingId) => {
    setSelectedBookingId(bookingId);
    setIsOpenBookingUpdateModal(true);
  };

  const selectKeyIssue = (bookingId) => {
    setSelectedBookingId(bookingId);
    setIsOpenKeyIssueModal(true);
  };

  const selectBookingCancel = (bookingId) => {
    setSelectedBookingId(bookingId);
    setIsOpenBookingCancelModal(true);
  };

  return (
    <Fragment>
      <div className='booking-list-header'>
        <div className='booking-list-building-filter-wrap'>
          <div className='booking-list-building-filter'>
            <select
              onChange={(e) => selectBuilding(e.target.value)}
            >
              <option value='' hidden>빌딩 선택</option>
              {buildingListItems.map((building, index) => (
                <option key={index} value={building.id}>{building.name}</option>
              ))}
            </select>
          </div>
          {floorListItems.map((floor, index) => (
            <div className='booking-list-floor-filter' key={index}>
              <p>{floor.name}</p>
            </div>
          ))}
        </div>
        <div className='view-type-wrap'>
          <button className={`view-type ${viewType === 'table' ? 'selected':''}`} onClick={() => changeViewType('table')}>
            <FontAwesomeIcon icon={faList}/>
          </button>
          <button className={`view-type ${viewType === 'card' ? 'selected':''}`} onClick={() => changeViewType('card')}>
            <FontAwesomeIcon icon={faTable}/>
          </button>
        </div>
      </div>
      <div className='content-title'>
        <div className='booking-list-status-filter-wrap'>
          <div className='booking-list-status-filter'>
            <p className='booking-list-status-filter-image'></p>
            <p className='booking-list-status-filter-name'>공실</p>
          </div>
          <div className='booking-list-status-filter'>
            <p className='booking-list-status-filter-image checkin'></p>
            <p className='booking-list-status-filter-name'>사용중</p>
          </div>
          <div className='booking-list-status-filter'>
            <p className='booking-list-status-filter-image checkout'></p>
            <p className='booking-list-status-filter-name'>퇴실 예정</p>
          </div>
          <div className='booking-list-status-filter'>
            <p className='booking-list-status-filter-image cleaning'></p>
            <p className='booking-list-status-filter-name'>청소중</p>
          </div>
          <div className='booking-list-status-filter'>
            <p className='booking-list-status-filter-image uninstalled'></p>
            <p className='booking-list-status-filter-name'>미설치</p>
          </div>
        </div>
        <div className='excel-upload' onClick={() => setIsOpenExcelUploadModal(true)}>
          <img className='excel-logo' src='../assets/images/excel.png' alt='excel_logo'></img>
          <span>예약 생성 엑셀 파일 업로드</span>
        </div>
      </div>
      <div className='booking-list-card-wrap'>
        <div className='booking-list-card-header'>
          <div></div>
          <div className='booking-list-time-filter-wrap'>
            <div className='booking-list-time-filter'>
              <div className='booking-list-time-filter-item' onClick={() => changePrevDate(filterItem.startAt)}>
                <FontAwesomeIcon icon={faAngleLeft}/>
              </div>
              <p>{bookingDateFormatter(filterItem.startAt)}</p>
              <div className='booking-list-time-filter-item' onClick={() => changeNextDate(filterItem.startAt)}>
                <FontAwesomeIcon icon={faAngleRight}/>
              </div>
            </div>
          </div>
          <div className='booking-list-refresh-wrap' onClick={() => listBookingApi()}>
            <div className='booking-list-refresh'>
              <FontAwesomeIcon icon={faSyncAlt}/>
              <p>목록 갱신하기</p>
            </div>
          </div>
        </div>
        <div className='booking-list-card-body'>
          {bookingListItems.map((booking, index) => (
            <div className='booking-card-wrap' key={index}>
              <div className={`booking-card-header ${booking.status || ''}`}>
                <p className='booking-card-header-room'>{booking.room_name}</p>
                <p className='booking-card-header-keys'>{['issued', 'expired'].includes(booking.status) ? `C${booking.cardkeys.length} / M${booking.mobilekeys.length} / P${booking.pincodes.length}`:''}</p>
              </div>
              <div className='booking-card-content'>
                <p>{booking.user_name || '-'}</p>
                <p>입실: {booking.checkin_at || '-'}</p>
                <p>퇴실: {booking.checkout_at || '-'}</p>
              </div>
              <div className='booking-card-footer'>
                <Fragment>
                  <button className='booking-card-button bblr-35' disabled={!booking.status} onClick={() => selectBookingDetail(booking.id)}>
                    <FontAwesomeIcon icon={faSearch}/>
                  </button>
                  <span className='booking-card-button-gab'></span>
                  <button className='booking-card-button' disabled={!booking.status} onClick={() => selectBookingUpdate(booking.id)}>
                    <FontAwesomeIcon icon={faPencilAlt}/>
                  </button>
                  <span className='booking-card-button-gab'></span>
                  <button className='booking-card-button' disabled={!booking.status} onClick={() => selectBookingCancel(booking.id)}>
                    <FontAwesomeIcon icon={faTrashAlt}/>
                  </button>
                  <span className='booking-card-button-gab'></span>
                  <button className='booking-card-button bbrr-35' onClick={() => selectKeyIssue(booking.id)}>
                    <FontAwesomeIcon icon={faKey}/>
                  </button>
                </Fragment>
                {/* {!booking.status ? (
                  <button className='booking-card-button bblr-35 bbrr-35' onClick={() => setIsOpenBookingCreateModal(true)}>
                    <FontAwesomeIcon icon={faKey}/>
                    <span>객실 키발급</span>
                  </button>
                ) : (
                  <Fragment>
                    <button className='booking-card-button bblr-35'>
                      <FontAwesomeIcon icon={faSearch}/>
                    </button>
                    <button className='booking-card-button' onClick={() => selectBookingUpdate(booking.id)}>
                      <FontAwesomeIcon icon={faPencilAlt}/>
                    </button>
                    <button className='booking-card-button' onClick={() => selectBookingCancel(booking.id)}>
                      <FontAwesomeIcon icon={faTrashAlt}/>
                    </button>
                    <button className='booking-card-button bbrr-35' onClick={() => selectKeyIssue(booking.id)}>
                      <FontAwesomeIcon icon={faKey}/>
                    </button>
                  </Fragment>
                )} */}
              </div>
            </div>
          ))}
        </div>
        <div className='booking-list-card-footer'>

        </div>
      </div>
      {/* <div className='form-item-add'>
        <button className='btn-item-add list' onClick={() => setIsOpenBookingCreateModal(true)}>
          <FontAwesomeIcon icon={faPlusCircle} className='icon-item-add'/>
          <span>예약 생성</span>
        </button>
      </div> */}
      {/* <Pagination
        total={bookingListTotal}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      /> */}
      <BookingDetail
        isOpen={isOpenBookingDetailModal}
        toggle={() => setIsOpenBookingDetailModal(!isOpenBookingDetailModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
      />
      <BookingCreate
        isOpen={isOpenBookingCreateModal}
        toggle={() => setIsOpenBookingCreateModal(!isOpenBookingCreateModal)}
        reload={() => listBookingApi()}
      />
      <ExcelUpload
        isOpen={isOpenExcelUploadModal}
        toggle={() => setIsOpenExcelUploadModal(!isOpenExcelUploadModal)}
        reload={() => listBookingApi()}
      />
      <BookingUpdate
        isOpen={isOpenBookingUpdateModal}
        toggle={() => setIsOpenBookingUpdateModal(!isOpenBookingUpdateModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
      />
      <KeyIssue
        isOpen={isOpenKeyIssueModal}
        toggle={() => setIsOpenKeyIssueModal(!isOpenKeyIssueModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
      />
      <BookingCancel
        isOpen={isOpenBookingCancelModal}
        toggle={() => setIsOpenBookingCancelModal(!isOpenBookingCancelModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
      />
    </Fragment>
  );
};

export default BookingListCard;